<template>
    <div class="">
        <div class="card">
            <div class="card-body shadow-sm">
                sales rep profile
            </div>
        </div>
    </div>
  
</template>

<script>
export default {
    data(){
        return {

        }
    },
    methods(){

    },
    created(){

    }

}
</script>

<style scoped lang="scss">
    .card {
        height: 2000px;
        width: 600px
    }
</style>
